import React, { useEffect, useState } from 'react'
import styled, { keyframes } from 'styled-components'
import { RCWidth, base, deepClone, generateDomainDot } from '../utils'
import Loading from './Loading'
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { useDispatch, useSelector } from 'react-redux';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { redNex } from '../Redux/nexSlice';
import NoData from './NoData';
import MultipleStopIcon from '@mui/icons-material/MultipleStop';
import BacklinkDistributionByDAChart from './BacklinkDistributionByDAChart';

function HighQualityBacklinks({ nexListn, _nex }) {
    const [data, setData] = useState([])
    const [url, setUrl] = useState('')

    const [selectedLinks, setSelectedLinks] = useState([])

    const [isLoading, setIsLoading] = useState(false)
    const [showInfo, setShowInfo] = useState(false);

    const [noInput1, setNoInput1] = useState(false)

    const [noData, setNoData] = useState(false)

    const user = useSelector(state=> state.user.user)
    const nx = useSelector(state=> state.nex.nex)

    const dispatch = useDispatch()


    const getData = async () => {
        if(url !== '') {
          setNoInput1(false)
          setNoData(false)
          setData([])

          const updateAnalytics = async () => {
            const tool = window.location.pathname.split('/').pop();
            let tools = deepClone(user.analytics.toolsUsage);
        
            if (isNaN(tools[tool]) || tools[tool] == 'NaN') {
                tools[tool] = 1;
            } else {
                tools[tool] = Number(tools[tool]) + 1;
            }
        
            await updateDoc(doc(db, 'users', user.id), { analytics: { toolsUsage: tools } });
        };


            setIsLoading(true)
              fetch(`${base}/res`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  type: 'hqb',
                  url: url,
                  userId: user.id
                })
              }).then(res=> res.json()).then(data=> {
                if(data.data.length === 1 && data.data[0].found === 'NA') setNoData(true)
                setData([data])
                setIsLoading(false)
                dispatch(redNex(nx))
                updateAnalytics()
              })
            } else {
              if(url.trim() === '') setNoInput1(true)
            }
    }

    const toggleInfo = () => {
        setShowInfo(!showInfo);
    };

    useEffect(()=> {
      if(isLoading) {
        const timerId = setTimeout(() => {
          if(data.length === 0) {
            setNoData(true)
            setIsLoading(false)
          }
        }, 30000);
        return () => clearTimeout(timerId);
      }
    }, [isLoading])

    const selectLinks = (i) => {
      setSelectedLinks(prev => {
        if (prev.includes(i)) {
          return prev.filter(index => index !== i);
        } else {
          return [...prev, i];
        }
      });
    };


    const selectAll = () => {
      setSelectedLinks(prev => {
        if (prev.length === data[0].data.length) {
          return [];
        } else {
          return data[0].data.map((_, index) => index);
        }
      });
    };


    const exportToCSV = (selectedIndexes) => {
      // Define the CSV headers, separating Anchor Text and Destination URL
      const headers = ['Page Title', 'Location', 'Anchor Text', 'Destination URL', 'Page Authority', 'Domain Authority', 'Found On'];
    
      // Filter the selected data based on the selected indexes
      const selectedData = selectedIndexes.map(index => data[0].data[index]);
    
      // Create the CSV rows
      const rows = selectedData.map(row => [
        row.titleLocation.title,     // Page Title
        row.titleLocation.location,  // Location
        row.anchorDest.anchorText,   // Anchor Text
        row.anchorDest.dest,         // Destination URL
        row.pa,                      // Page Authority
        row.da,                      // Domain Authority
        row.found                    // Found On
      ]);
    
      // Combine headers and rows into a single CSV string
      const csvContent = [
        headers.join(','),           // Add headers
        ...rows.map(row => row.join(','))  // Add each row
      ].join('\n');                   // Join with newline characters
    
      // Create a Blob from the CSV content
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    
      // Create a link to trigger the download
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      link.href = url;
      link.setAttribute('download', 'selected_links.csv');
    
      // Append link to body, trigger download, then remove the link
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };

    const getHighestDA = (data) => {
      // Extract the DA values and convert them to numbers
      const daValues = data.map(item => parseInt(item.da, 10));
    
      // Find the highest DA value
      const highestDA = Math.max(...daValues);
    
      return highestDA;
    };


    const getLowestDA = (data) => {
      // Extract the DA values and convert them to numbers
      const daValues = data.map(item => parseInt(item.da, 10));
    
      // Find the lowest DA value
      const lowestDA = Math.min(...daValues);
    
      return lowestDA;
    };

    function filterByNewest() {
      let arr = [...data]
      arr[0].data.sort((a, b) => new Date(b.found) - new Date(a.found));
      setData(arr)
    }
    


  return (
    <HighQualityBacklinksContainer>
            <HighQualityBacklinksInputContainer>
            <div style={{display: 'flex', flexDirection: 'column'}}>
            <h2>
                High Quality Backlinks
                {false && <button onClick={toggleInfo} style={{ marginLeft: '10px', cursor: 'pointer', border: 'none', background: 'none', outline: 'none' }}>
                    {showInfo ? <RemoveIcon style={{color: 'var(--bl-color)'}}/> : <AddIcon style={{color: 'var(--bl-color)'}}/>}
                </button>}
            </h2>
            {showInfo && (
                <HeaderSpan>
                    High-quality backlinks are links from reputable websites with relevant content and high domain authority, positively impacting a website's search engine rankings and credibility. Recognizing them helps in enhancing website visibility, improving SEO performance, and establishing authority in the digital space.
                </HeaderSpan>
            )}</div>
            <HighQualityBacklinksInnerInputContainer>
                <div style={{position: 'relative', marginBottom: '20px'}}><label style={{position: 'absolute', transform: 'translateY(-70%)', left: '23px', top: '20%', fontSize: 'small'}}>Your Website or Webpage</label><input type='url' placeholder='example.com' style={{marginLeft: '20px', borderColor: noInput1? 'red': ''}} value={url} onChange={e=> setUrl(e.target.value)}/></div>
                {nx !== 0 && <button onClick={()=> !isLoading? getData() : ()=> {}} style={isLoading ? {backgroundColor: 'lightgray', color: 'gray', cursor: 'not-allowed'}: {}}>{!isLoading ?'Get Data': 'Getting Data ...'}</button>}
                {nx === 0 && <button style={{backgroundColor: 'lightgray', color: 'red', cursor: 'not-allowed'}}>Insufficient Nexilum units!</button>}
            </HighQualityBacklinksInnerInputContainer>

            {data.length !== 0 && !isLoading && !noData && <ChartContainer>
                <h3>Backlink Distribution By Domain Authority</h3>
                <BacklinkDistributionByDAChart data={data[0].data} />
            </ChartContainer>}
            </HighQualityBacklinksInputContainer>

        {data.length !== 0 && !isLoading && !noData && <OperationsContainer>
            <div>
              <h4>Total Links</h4>
              <h4>{data[0].data.length}</h4>
            </div>
            <div>
              <h4>Highest Domain Authority</h4>
              <h4>{getHighestDA(data[0].data)}</h4>
            </div>
            <div>
              <h4>Lowest Domain Authority</h4>
              <h4>{getLowestDA(data[0].data)}</h4>
            </div>
            {<button className='export_btn' onClick={()=> exportToCSV(selectedLinks)} style={{visibility: selectedLinks.length !== 0? 'visible': 'hidden'}}>Export to CSV</button>}
            </OperationsContainer>}

        {data.length !== 0 && !isLoading && !noData && <HighQualityBacklinksResContainer>

            {false && <HighQualityBacklinksInfoContainer>
                <div>
                    <h2>{data[0].info.backlinks?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || <span style={{fontSize: 'small', color: 'lightgray'}}>Data unavailable</span>}</h2>
                    <h4>Backlinks</h4>
                </div>
                <div>
                    <h2>{data[0].info.uniqueBacklinks?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || <span style={{fontSize: 'small', color: 'lightgray'}}>Data unavailable</span>}</h2>
                    <h4>Unique backlinks</h4>
                </div>
                <div>
                    <h2>{data[0].info.hpLinks?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ",") || <span style={{fontSize: 'small', color: 'lightgray'}}>Data unavailable</span>}</h2>
                    <h4>Links to homepage</h4>
                </div>
                <div>
                    <h2>{data[0].info.nofollowBacklinks?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || <span style={{fontSize: 'small', color: 'lightgray'}}>Data unavailable</span>}</h2>
                    <h4>Nofollow backlinks</h4>
                </div>
            </HighQualityBacklinksInfoContainer>}


            <HighQualityBacklinksRes style={{fontWeight: '400', fontSize: 'small'}}>
                <p className='checkbox' onClick={()=> selectAll()} style={{backgroundColor: (selectedLinks.length === data[0].data.length)? 'var(--bl-color': ''}}></p>
                <p style={{width: '400px', marginRight: '10px'}}>Page Title & Location</p>
                <p style={{width: '250px'}}>Anchor Text & Destination</p>
                <p style={{width: '130px'}}>Page Authority</p>
                <p style={{width: '130px'}}>Domain Authority</p>
                <p style={{width: '160px', marginLeft: 'auto'}}>Found On <span onClick={()=> filterByNewest()}><MultipleStopIcon /> Recent</span></p>
            </HighQualityBacklinksRes>

            <div style={{overflowX: 'hidden', overflowY: 'scroll'}}>
            {data[0].data.map((bl, i) => {
                return (
                    <HighQualityBacklinksRes style={{backgroundColor: selectedLinks.includes(i)? '#cefae6be': ''}}>
                        <p className='checkbox' style={{backgroundColor: selectedLinks.includes(i)? 'var(--bl-color)': ''}} onClick={()=> selectLinks(i)}></p>
                        <div style={{width: '400px', display: 'flex', flexDirection: 'column', marginRight: '30px', wordWrap: 'break-word'}}>
                            <p className='title'>{bl.titleLocation?.title}</p>
                            <p className='location_url' onClick={()=> window.open(bl.titleLocation.location, '_blank')}>{bl.titleLocation.location}</p>
                        </div>
                        <div style={{width: '250px', display: 'flex', flexDirection: 'column', wordWrap: 'break-word', marginRight: '20px'}}>
                            <p className='anchor_text'>{bl.anchorDest.anchorText}</p>
                            <p className='dest_url' onClick={()=> window.open(bl.anchorDest.dest, '_blank')}>{bl.anchorDest.dest}</p>
                            {bl.isNofollow && <p className='nofollow'>Nofollow</p>}
                        </div>
                        <p style={{width: '130px', display: 'flex', flexDirection: 'row', gap: '5px', alignItems: 'center'}}>{generateDomainDot(10, bl.pa)}{bl.pa}</p>
                        <p style={{width: '130px', display: 'flex', flexDirection: 'row', gap: '5px', alignItems: 'center', marginRight: '20px'}}> {generateDomainDot(10, bl.da)}{bl.da}</p>
                        <p style={{width: '160px', marginLeft: 'auto'}}>{bl.found}</p>
                    </HighQualityBacklinksRes>
                )
            })}</div>
        </HighQualityBacklinksResContainer>}
        {isLoading && <Loading />}
        {noData && <NoData />}

        {data.length == 0 && !isLoading && !noData && <Intro>

          <h3>Tool Overview</h3>
          <br />
          <p>
            The High Quality Backlinks Tool identifies and provides insights into high-quality backlinks pointing to your website. 
            By analyzing these backlinks, you can understand their impact on your site's authority and make strategic decisions to enhance your SEO.
          </p>
          <br /><br />
          
          <h3>Instructions</h3>
          <br />
          <p>1. Enter the URL of your website</p>
          <p>2. Click "Get Data" to view a report on high-quality backlinks</p>
          <br /><br />
          
          <h3>Tips</h3>
          <br />
          <p>Focus on obtaining backlinks from reputable sites with high domain authority to strengthen your site’s credibility and improve rankings</p>

        </Intro>}
    </HighQualityBacklinksContainer>
  )
}

export default HighQualityBacklinks


const fadeInAnimation = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`


const HighQualityBacklinksContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: ${RCWidth};
`


const HighQualityBacklinksInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 3px;
  box-shadow: 2px 2px 16px -8px rgb(239, 239, 239);
  background-color: white;
  margin-inline: 20px;
  padding: 20px;
  margin-top: 25px;
  z-index: 2;

  > div > h2 {
    font-weight: 100;
    margin-bottom: 20px;
  }

  > div > input {
    outline: none;
    border-radius: 2px;
    width: 200px;
    height: 30px;
    border: 1px solid rgba(235, 235, 235);
    box-shadow: 1px 10px 30px -7px rgba(235, 235, 235);
    padding-inline: 5px;
    margin-block: 10px;
    color: var(--bl-color);
  }

  > div > input::placeholder {
    color: rgba(180, 180, 180);
  }

  > div > .select-country {
    outline: none;
    border-radius: 2px;
    width: 200px;
    height: 30px;
    border: 1px solid rgba(235, 235, 235);
    box-shadow: 1px 10px 30px -7px rgba(235, 235, 235);
    padding-inline: 5px;
    margin-block: 10px;
    margin-left: 20px;
    color: var(--bl-color);
  }

  > div > button {
    border: none;
    border-radius: 2px;
    height: 30px;
    border: 1px solid rgba(235, 235, 235);
    box-shadow: 1px 10px 30px -7px rgba(235, 235, 235);
    padding-inline: 5px;
    margin-block: 10px;
    padding: 5px;
    margin-left: 60px;
    cursor: pointer;
    background-color: var(--bl-color);
    color: white;
  }

  > div > button:hover {
    color: var(--bl-color);
    background-color: rgb(239, 239, 239);
  }
`


const HighQualityBacklinksInnerInputContainer = styled.div`
  display: flex;
  margin-top: 20px;

  > div > input {
    outline: none;
    border-radius: 2px;
    width: 200px;
    height: 30px;
    border: 1px solid rgba(235, 235, 235);
    box-shadow: 1px 10px 30px -7px rgba(235, 235, 235);
    padding-inline: 5px;
    margin-block: 10px;
    color: var(--bl-color);
    padding-left: 100px;
    font-size: medium;
  }

  > div > input::placeholder {
    color: rgba(180, 180, 180);
  }
`


const HighQualityBacklinksResContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
  margin: 20px;
  overflow-x: hidden;
  overflow-y: hidden;
  background-color: white;
  border-radius: 2px;
  z-index: 2;
  margin-bottom: 70px;
  padding-bottom: 10px;

  opacity: 0;
  animation: ${fadeInAnimation} 0.6s ease-in-out forwards;
`


const HighQualityBacklinksRes = styled.div`
    display: flex;
    flex-direction: row;
    padding: 10px;
    margin-block: 5px;
    border-bottom: 1px solid rgb(230, 230, 230);
    justify-content: space-between;

    > p {
      display: flex;
      align-items: center;
      gap: 10px;
      font-family: 'Quicksand';

      > span {
      font-size: small;
      color: gray;
      cursor: pointer;
      transition: color 0.3s ease-in-out;
      display: flex;
      align-items: center;
      gap: 3px;

      > .MuiSvgIcon-root {
        transform: rotate(90deg);
      }

      &:hover {
        color: var(--bl-color);
      }
    }
    }

    .checkbox {
      width: 15px;
      height: 15px;
      border: 1px solid lightgray;
      border-radius: 3px;
      margin-right: 10px;

      &:hover {
        cursor: pointer;
        background-color: #ebebeb;
      }
    }


    > div {
    > .title {
      font-size: 13px;
      font-weight: bold;
    }

    > .location_url {
      font-size: 13px;
      color: blue;
      cursor: pointer;
      transition: text-decoration 0.3s ease-in-out;
      width: fit-content;
      word-break: break-all;

      &:hover {
        text-decoration: underline;
      }
    }

    > .dest_url {
      font-size: 13px;
      color: blue;
      cursor: pointer;
      transition: text-decoration 0.3s ease-in-out;
      width: fit-content;

      &:hover {
        text-decoration: underline;
      }
    }

    > .anchor_text {
      font-size: small;
      font-weight: bold;
    }

    > .nofollow {
      padding: 3px;
      border: none;
      border-radius: 5px;
      background-color: red;
      color: white;
      width: fit-content;
      font-size: 12px;
      margin-top: 5px;
      font-weight: bold;
    }
  }
`

const HeaderSpan = styled.span`
    font-weight: 300;
    color: var(--bl-color);
    font-size: medium;

    opacity: 0;
    animation: ${fadeInAnimation} 0.6s ease-in-out forwards;
`


const HighQualityBacklinksInfoContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: left;
    gap: 100px;
    margin-bottom: 10px;
    border-bottom: 1px solid rgb(230, 230, 230);

    > div {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        gap: 10px;
    }

    > div > h2 {
        font-weight: 300;
        font-size: medium;
    }

    > div > h4 {
        font-weight: 300;
        color: gray;
    }

    > .export_btn {
      padding: 6px 12px;
      border: none;
      background-color: var(--bl-color);
      cursor: pointer;
      transition: background-color 0.3s ease-in-out;
      color: white;
      border-radius: 3px;
      margin-bottom: 10px;
      margin-left: auto;
      margin-right: 5px;

      opacity: 0;
      animation: ${fadeInAnimation} 0.3s ease-in-out forwards;

      &:hover {
        background-color: white;
        color: var(--bl-color);
      }
    }
`


const Intro = styled.div`
  display: flex;
  flex-direction: column;
  padding: 30px 20px 20px 20px;

  opacity: 0;
  animation: ${fadeInAnimation} 0.3s ease-in-out forwards;

  > h3 {
    color: white;
    font-family: 'Quicksand';
    font-weight: 500;
  }

  > p {
    color: white;
    font-family: 'Quicksand';
    width: 60%;
  }
`


const OperationsContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  z-index: 1000;
  align-items: center;
  padding-top: 5px;
  gap: 50px;
  background-color: transparent;

  > div {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        gap: 10px;
    }

    > div > h2 {
      font-family: 'Quicksand';
      margin-left: 20px;
      color: white;
      font-weight: 300;
    }

    > div > h4 {
      font-family: 'Quicksand';
      margin-left: 20px;
      color: white;
      font-weight: 300;
    }


  > h4 {
    font-family: 'Quicksand';
    margin-left: 20px;
    color: white;
    font-weight: 300;

    > span {
      font-family: 'Quicksand';
    }
  }


  > .export_btn {
      padding: 6px 12px;
      border: none;
      background-color: var(--bl-color);
      cursor: pointer;
      transition: background-color 0.3s ease-in-out;
      color: white;
      border-radius: 3px;
      margin-left: auto;
      margin-right: 25px;
      margin-top: 10px;

      opacity: 0;
      animation: ${fadeInAnimation} 0.3s ease-in-out forwards;

      &:hover {
        background-color: transparent;
        color: white;
      }
    }
`


const ChartContainer = styled.div`
  display: flex;
  width: 500px;
  position: absolute;
  top: 40px;
  right: 120px;
  height: 300px;
  flex-direction: column;

  > h3 {
    font-size: small;
    font-weight: 300;
    font-family: 'Quicksand';
  }
`